import { defineComponent } from 'vue';

import './LoadingZoo.scss';
import { NSpace, NText } from 'naive-ui';

export const LoadingZoo = defineComponent({
	name: 'LoadingZoo',
	props: {
		hideText: {
			type: Boolean,
			default: false,
		},

		size: {
			type: Number,
			default: 48,
		},
	},
	render() {
		return (
			<NSpace vertical align="center" class="active">
				<div class="loading-zoo">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="18.8638mm"
						height="13.9893mm"
						version="1.1"
						style={{
							shapeRendering: 'geometricPrecision',
							textRendering: 'geometricPrecision',
							imageRendering: 'auto',
							fillRule: 'evenodd',
							clipRule: 'evenodd',
						}}
						viewBox="0 0 727.44 539.47"
					>
						<defs>
							<style>
								{`
                                    .fil0 { fill: #108678; fill-rule: nonzero; }
                                    @keyframes float {
                                        0% { transform: translateY(0px); }
                                        50% { transform: translateY(-10px); }
                                        100% { transform: translateY(0px); }
                                    }
                                    .loading-zoo svg {
                                        animation: float 2s ease-in-out infinite;
                                    }
                                `}
							</style>
						</defs>
						<g id="Camada_x0020_1">
							<metadata id="CorelCorpID_0Corel-Layer" />
							<path
								class="fil0"
								d="M630.35 212.03c-6.35,5.44 -17.93,2.33 -25.88,-6.93 -7.97,-9.27 -9.27,-21.19 -2.94,-26.64 6.33,-5.42 17.9,-2.33 25.88,6.94 7.95,9.26 9.27,21.18 2.94,26.63zm30.75 -25.12c-9.89,-35.03 -29.46,-66.05 -62.48,-83.58 -26.2,-13.93 -52.81,-27.04 -79.55,-39.92 0.8,14.92 0.93,31.38 -2.09,33.63 -0.07,0.02 -0.11,0.11 -0.19,0.2 -0.43,0.56 -3.24,1.69 -11.28,-40.37 -18.68,-8.97 -37.43,-17.86 -56.05,-26.91 -20.26,-9.83 -40.63,-19.52 -60.91,-29.11 -4.19,-1.99 -9.26,-0.37 -11.45,3.74 -35.44,65.63 -59.55,132.46 -49.35,207.45 0.97,7.13 8.06,15.49 14.58,19.48 14.79,9.22 30.02,17.69 45.33,26.11 6.33,3.45 12.87,6.5 19.52,9.18 3.22,1.28 6.46,2.57 9.66,3.84 6.89,2.72 13.91,5.03 21.06,6.93l12.18 3.15c3.82,1.01 7.88,-0.72 9.83,-4.19l28.3 -68.23c3.84,-6.18 4.99,-0.17 4.73,1.19l-17.28 81.64c-0.26,3.65 1.84,7.11 5.18,8.62l51.27 22.4c9.16,3.95 19.12,5.6 29.07,4.67 33.09,-3.17 65.57,-8.38 97.09,-19.83 -13.13,23.82 -39.07,35.14 -66.09,41.39l12.2 5.31c0,0 2.53,89.29 -23.58,155.38 -0.58,4.24 1.79,8.19 5.81,9.57l22.25 7.86c2.92,0.97 -0.08,5.92 5.85,6.15 0.41,-0.41 1.58,-2.85 2.68,-5.38 1.1,-2.46 2.16,-4.99 2.42,-5.59 2.46,-5.62 4.51,-12.05 7.6,-21.04 0,-0.13 0.07,-0.17 0.07,-0.26 1.45,-4.36 3.17,-9.33 5.23,-15.19 0,-0.08 0.07,-0.19 0.13,-0.3 0.04,-0.13 0.04,-0.15 0.08,-0.3 1.97,-5.51 4.3,-11.86 7.04,-19.12 30.5,-87.84 36.5,-175.75 36.95,-182.33 -1.62,-32.31 -6.76,-64.47 -15.81,-96.24z"
							/>
							<path
								class="fil0"
								d="M682.11 297.76l-0.25 17.91c18.33,-5.83 38.71,-15.18 45.58,-34 -14.6,7.71 -29.78,12.54 -45.33,16.09z"
							/>
							<path
								class="fil0"
								d="M558.12 495.97c-0.13,0.78 -0.26,1.57 -0.43,2.4 -0.99,5.51 -2.18,11.21 -3.41,16.54 -3.3,14.47 -6.81,24.56 -6.81,24.56l-57.34 -0.39 -19.7 0c2.66,-8.72 0.2,-18.83 -6.65,-24.53l-140.71 -121.34c-9.61,-8.01 -22.59,-7.78 -31.99,0.56l-62.1 55.21 0 -14.58c0,-6.26 -4.36,-11.34 -9.76,-11.34l-40.8 0c-5.38,0 -9.74,5.07 -9.74,11.34l0 51.08 -36.03 37.04c-3.76,4.45 -5.34,10.65 -4.47,16.57l-74.41 0c-9.68,0 -17.28,-8.4 -16.44,-18.16 6.98,-80.84 18.92,-161.69 44.43,-238.58l-74.1 76.28c-20.89,-61.38 7.08,-17.8 11.01,-24.28 44.47,-73.5 106.18,-129.72 183.44,-166.14 19.74,-9.26 61.75,-28.16 81.73,-31.92 3.93,-0.73 6.84,-2.39 10.91,0.11 15.18,9.33 -9.63,83.8 24.17,111.92 68.14,39.48 143.89,68.14 212.1,107.1 7.23,4.15 25.81,13.59 30.36,18.38 14.92,15.78 3.37,84.32 -3.26,122.16z"
							/>
						</g>
					</svg>
				</div>
				{!this.hideText && (
					<div>
						<NText depth="3" strong>
							Carregando...
						</NText>
					</div>
				)}
			</NSpace>
		);
	},
});
